const TestIcon = (
  <svg
    className="fill-current"
    width="18"
    height="18"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.707 12.707 10.414 15l-1.414-1.414 2.293-2.293a1 1 0 0 0-1.414-1.414l-2.293 2.293-1.879-1.879a1 1 0 0 0-1.414 1.414l.352.352-1.134 1.135a5.001 5.001 0 0 0-.638 6.519l-2.58 2.58a1 1 0 0 0 1.414 1.414l2.58-2.58a5.003 5.003 0 0 0 6.519-.638l1.135-1.134.352.352a1 1 0 0 0 1.414-1.414l-1.879-1.879 2.293-2.293a1 1 0 0 0-1.414-1.414Zm-3.315 6.368a3.163 3.163 0 0 1-4.467 0 3.162 3.162 0 0 1 0-4.467l1.134-1.135 4.467 4.467-1.134 1.135ZM23.707.293a1 1 0 0 0-1.414 0l-2.58 2.58a5.003 5.003 0 0 0-6.519.638l-1.135 1.135-.353-.353a1 1 0 1 0-1.414 1.414l8 8a1 1 0 0 0 1.414-1.414l-.353-.353 1.135-1.135a5.003 5.003 0 0 0 .638-6.519l2.58-2.58a1 1 0 0 0 0-1.414Zm-4.632 9.099-1.135 1.135-4.467-4.467 1.135-1.135a3.162 3.162 0 0 1 4.467 0 3.163 3.163 0 0 1 0 4.467Z"
      fill="currentColor"
    />
  </svg>
);

export default TestIcon;
